import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { claimDailyCheckInReward, getDailyCheckIn } from '@/api/daily-check-in';
import { authClient } from '@/auth/client';
import { invalidateAllCredits } from './use-credits';

function userCheckInKey(userId: string | null | undefined) {
  return userId ?? 'anonymous';
}

export const dailyCheckInKeys = {
  all: ['daily-check-in'] as const,
  status: (userId?: string | null) =>
    [...dailyCheckInKeys.all, 'status', userCheckInKey(userId)] as const,
};

export function useDailyCheckIn() {
  const { data: session, isPending: isSessionPending } =
    authClient.useSession();
  const userId = session?.user?.id;

  return useQuery({
    queryKey: dailyCheckInKeys.status(userId),
    queryFn: () => getDailyCheckIn(),
    enabled: typeof window !== 'undefined' && !isSessionPending && !!userId,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function useClaimDailyCheckIn() {
  const { data: session } = authClient.useSession();
  const queryClient = useQueryClient();
  const userId = session?.user?.id;

  return useMutation({
    mutationFn: () => claimDailyCheckInReward(),
    onSuccess: async (status) => {
      queryClient.setQueryData(dailyCheckInKeys.status(userId), status);
      await invalidateAllCredits(queryClient);
    },
  });
}
